import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { track } from 'ha/modules/Analytics/actions';
import {
  getPageInfo,
  getAnalyticsForFilters,
  getAnalyticsForListings,
  getCountryCode,
  getCityCanonical,
  getAdvertiserName,
} from 'ha/pages/Search/selectors';
import { getIsMobile } from 'ha/modules/UI/selectors';
import { GlobalState } from 'ha/types/store';
import ListingPreviewCardTracked from '../components/ListingPreviewCardTracked';

export default connect(
  (state: GlobalState) => ({
    pageInfo: getPageInfo(state),
    countryCode: getCountryCode(state),
    cityCanonical: getCityCanonical(state),
    filtersAnalytics: getAnalyticsForFilters(state),
    listingsAnalytics: getAnalyticsForListings(state),
    isAdvertiserSearch: Boolean(getAdvertiserName(state)),
    isMobile: getIsMobile(state),
  }),
  { track },
)(withRouter(ListingPreviewCardTracked));
